export const PARTICIPANT_ROLES = {
  LEGAL_COUNSEL: "LEGAL_COUNSEL",
  SELLER: "SELLER",
  BUYER: "BUYER",
  EXPERT: "EXPERT",
  NOTARY: "NOTARY",
  BROKER: "BROKER",
  INVESTOR: "INVESTOR",
  LENDER: "LENDER",
  BORROWER: "BORROWER",
  OTHER: "OTHER"
};

export const PARTICIPANT_ROLES_LABELS = {
  [PARTICIPANT_ROLES.LEGAL_COUNSEL]: "Conseil Juridique",
  [PARTICIPANT_ROLES.SELLER]: "Vendeur",
  [PARTICIPANT_ROLES.BUYER]: "Acquéreur",
  [PARTICIPANT_ROLES.EXPERT]: "Expert",
  [PARTICIPANT_ROLES.NOTARY]: "Notaire",
  [PARTICIPANT_ROLES.BROKER]: "Courtier",
  [PARTICIPANT_ROLES.INVESTOR]: "Investisseur",
  [PARTICIPANT_ROLES.LENDER]: "Prêteur",
  [PARTICIPANT_ROLES.BORROWER]: "Emprunteur",
  [PARTICIPANT_ROLES.OTHER]: "Autre"
};
